import React from 'react';
import classNames from 'classnames';

interface ActivityIconProps {
  className?: string;
}

// lucide Activity, wrapped like an antd icon like ConciergeBellIcon (lucide is not a web dependency).
const ActivityIcon: React.FC<ActivityIconProps> = ({ className }) => (
  <span aria-hidden="true" className={classNames('anticon', className)}>
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
    </svg>
  </span>
);

export default ActivityIcon;
